import React from 'react';
import { WrenchIcon, CalendarIcon, FactoryIcon, HandshakeIcon, ShieldCheckIcon, EyeIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const advantageItems = [{
  titleKey: 'advantages.item1.title',
  descKey: 'advantages.item1.desc',
  Icon: WrenchIcon
}, {
  titleKey: 'advantages.item2.title',
  descKey: 'advantages.item2.desc',
  Icon: CalendarIcon
}, {
  titleKey: 'advantages.item3.title',
  descKey: 'advantages.item3.desc',
  Icon: FactoryIcon
}, {
  titleKey: 'advantages.item4.title',
  descKey: 'advantages.item4.desc',
  Icon: HandshakeIcon
}, {
  titleKey: 'advantages.item5.title',
  descKey: 'advantages.item5.desc',
  Icon: ShieldCheckIcon
}, {
  titleKey: 'advantages.item6.title',
  descKey: 'advantages.item6.desc',
  Icon: EyeIcon
}];
export function Advantages() {
  const {
    t
  } = useLanguage();
  return <section id="advantages" className="w-full bg-navy py-20 sm:py-28" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <ScrollFadeIn data-id="element-37">
          <div className="mb-4" data-id="element-38">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-39">
              {t('advantages.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-12" data-id="element-40">
            {t('advantages.heading')}
          </h2>
        </ScrollFadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-41">
          {advantageItems.map((item, i) => <ScrollFadeIn key={item.titleKey} delay={i * 60} data-id="element-42">
              <div className="p-6 bg-graphite border border-slate-700/50 rounded h-full" data-id="element-43">
                <div className="w-10 h-10 flex items-center justify-center rounded bg-electric/10 mb-4" data-id="element-44">
                  <item.Icon className="w-5 h-5 text-electric" data-id="element-45" />
                </div>
                <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-2" data-id="element-46">
                  {t(item.titleKey)}
                </h3>
                <p className="text-xs text-slate-500 leading-relaxed" data-id="element-47">
                  {t(item.descKey)}
                </p>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}